import { createPortal } from "react-dom";

import { Modal } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { contactUsModalConfig } from "./configs";
import ModalContent from "./modalContent/ModalContent";

type ContactUsThanksPortableModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

/** Thanks modal after gain-access — portaled to `document.body` so nested layouts cannot clip it. */
export const ContactUsThanksPortableModal = ({ isOpen, onClose }: ContactUsThanksPortableModalProps) => {
    if (!isOpen) {
        return null;
    }

    return createPortal(
        <Modal
            isOpen
            customStyles={contactUsModalConfig}
            onRequestClose={onClose}
        >
            <Modal.CloseButton onClick={onClose} />
            <ModalContent
                title={translate("hook_modal.get_feature.success.title")}
                subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
                buttonText={translate("si.modal.get_feature.success.btn.close")}
                onClick={onClose}
            />
        </Modal>,
        document.body,
    );
};
